import {h} from 'preact';
import Icon from '@components/common/Icon';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';

const NavItem = ( {title, url, className = '', children} ) => {
    const hasChildren = !isEmptyOrNil( children );
    const menuAttr = hasChildren ? {'data-menu-trigger': true} : {};
    return (
        <li {...menuAttr} className={`whitespace-no-wrap hover:text-white ${className}`}>
            <a href={url}
               data-prevent-touch-nav
               className="nav-drop-menu--pointer flex items-center h-12 inline-block mx-3 xl:mx-4 text-inherit hover:text-inherit">
                {title}
                {hasChildren && <Icon.ui name="menu-arrow-down" className="text-lg align-middle fade-in"/>}
            </a>
            {children}
        </li>
    )
};

export default NavItem;